export const name = "GENERATE_RANGE_ARRAY";
export const summary = `Splits a range into an array of subranges.    For more information, see Range functions.`;
export const reference = `
## GENERATE_RANGE_ARRAY

Splits a range into an array of subranges.   
For more information, see Range functions.

\`\`\`
GENERATE_RANGE_ARRAY(range_to_split, step_interval)
\`\`\`

### 

\`\`\`
GENERATE_RANGE_ARRAY(range_to_split, step_interval, include_last_partial_range)
\`\`\`


### Description

Splits a range into an array of subranges.


### Definitions

- \`range_to_split\`: The \`RANGE<T>\` value to split.
- \`step_interval\`: The \`INTERVAL\` value, which determines the maximum size of each subrange in the resulting array. An interval single date and time partis supported, but an interval range of date and time parts isn't.

- \`include_last_partial_range\`: A \`BOOL\` value, which determines whether or not to include the last subrange if it's a partial subrange. If this argument isn't specified, the default value is \`TRUE\`.


### Details

Returns \`NULL\` if any input is\`NULL\`.


### Return type

\`ARRAY<RANGE<T>>\`


### Examples

In the following example, a date range between \`2020-01-01\` and \`2020-01-06\`is split into an array of subranges that are one day long. There are no partial ranges.



\`\`\`
SELECT GENERATE_RANGE_ARRAY(
  RANGE(DATE '2020-01-01', DATE '2020-01-06'),
  INTERVAL 1 DAY) AS results;

/*----------------------------+
 | results |
 +----------------------------+
 | [ |
 | [2020-01-01, 2020-01-02), |
 | [2020-01-02, 2020-01-03), |
 | [2020-01-03, 2020-01-04), |
 | [2020-01-04, 2020-01-05), |
 | [2020-01-05, 2020-01-06), |
 | ] |
 +----------------------------*/
\`\`\`

In the following examples, a date range between \`2020-01-01\` and \`2020-01-06\`is split into an array of subranges that are two days long. The final subrange is smaller than two days:



\`\`\`
SELECT GENERATE_RANGE_ARRAY(
  RANGE(DATE '2020-01-01', DATE '2020-01-06'),
  INTERVAL 2 DAY) AS results;

/*----------------------------+
 | results |
 +----------------------------+
 | [ |
 | [2020-01-01, 2020-01-03), |
 | [2020-01-03, 2020-01-05), |
 | [2020-01-05, 2020-01-06) |
 | ] |
 +----------------------------*/
\`\`\`



\`\`\`
SELECT GENERATE_RANGE_ARRAY(
  RANGE(DATE '2020-01-01', DATE '2020-01-06'),
  INTERVAL 2 DAY,
  TRUE) AS results;

/*----------------------------+
 | results |
 +----------------------------+
 | [ |
 | [2020-01-01, 2020-01-03), |
 | [2020-01-03, 2020-01-05), |
 | [2020-01-05, 2020-01-06) |
 | ] |
 +----------------------------*/
\`\`\`

In the following example, a date range between \`2020-01-01\` and \`2020-01-06\`is split into an array of subranges that are two days long, but the final subrange is excluded because it's smaller than two days:



\`\`\`
SELECT GENERATE_RANGE_ARRAY(
  RANGE(DATE '2020-01-01', DATE '2020-01-06'),
  INTERVAL 2 DAY,
  FALSE) AS results;

/*----------------------------+
 | results |
 +----------------------------+
 | [ |
 | [2020-01-01, 2020-01-03), |
 | [2020-01-03, 2020-01-05) |
 | ] |
 +----------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/range-functions
`;
